import React from 'react';
import {Nav, Button, Container, Row, Col} from 'react-bootstrap';
import {StaticQuery, graphql, Link} from 'gatsby';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  margin-top: 2rem;
  margin-bottom: 2rem;
  @media (min-width: 576px) {
    margin-top: 3rem;
    margin-bottom: 0;
  }
`;
export default function Sidenav(props, {data}) {
  const words = props.title.split(' ');
  const wrappedParts = words.map((word, index) => {
    // console.log(word);
    return (
      <span className="text-dark" key={index}>
        {word}
      </span>
    );
  });
  return (
    <div className={props.className}>
      <Nav defaultActiveKey="/home" className="">
        <Container>
          <Row>
            <Col md={3}>
              <h1 className="mt-3 mb-5 cover-deco-title h2 text-dark text-uppercase text-wrap">
                {wrappedParts}
              </h1>
            </Col>
            <Col md={9}>
              <div className="toc">
                <StaticQuery
                  query={graphql`
                    {
                      allMdx(sort: {fields: [frontmatter___date], order: ASC}) {
                        nodes {
                          id
                          slug
                          excerpt(pruneLength: 250)
                          frontmatter {
                            title
                            description
                            date(formatString: "YYYY MMMM Do")
                          }
                        }
                      }
                    }
                  `}
                  render={data =>
                    data.allMdx.nodes.map(item => (
                      <Link
                        className="text-decoration-none"
                        key={item.id}
                        to={`/${item.slug}`}
                        activeClassName="active"
                      >
                        <h2>
                          {item.frontmatter.title.replace(/<[^>]+>/g, '')}
                        </h2>
                        <p>{item.frontmatter.description}</p>
                      </Link>
                    ))
                  }
                />
              </div>
            </Col>
          </Row>
        </Container>
        {/* <StyledButton variant="primary">Download the report</StyledButton> */}
      </Nav>
    </div>
  );
}

/*
  
  */
